import ConfirmDialog from '../../components/ConfirmDialog';
import SwitchComponent from '../../components/switch';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { Avatar, Box, Button, Grid, TextField, Typography, Select, MenuItem, IconButton, FormControl, Rating } from '@mui/material';
import { MerChantModel } from '../../models/merChantModel';
import { MerchantEnum } from '../../enums/merchantEnum';
import { ArrowBack } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import useMerchantDetailController from './controller';
import { IMAGE_MERCHANT_URL } from '../../constants/imageUrl';

const MerchantDetailView = () => {
    const controller = useMerchantDetailController()
    const { t } = useTranslation("global");
    return (
        <Box>
            <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                {t("merchantDetail_page.Merchant Detail")}
            </Typography>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6} md={3}>
                    <Box
                        sx={{
                            p: 8,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '10px'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Avatar
                                alt=""
                                style={{ cursor: 'pointer', width: 120, height: 120, objectFit: 'contain' }}
                                src={IMAGE_MERCHANT_URL + controller.merchantData?.image?.url}
                                onClick={() => window.open(IMAGE_MERCHANT_URL + controller.merchantData?.image?.url)}
                            />
                        </Box>
                        {/* <Box mt={2}>
                            <Typography textAlign="center">Allowed *.jpeg, *.jpg, *.png</Typography>
                            <Typography textAlign="center">Max size of 3.1 MB</Typography>
                        </Box> */}
                    </Box>


                    <Box
                        sx={{
                            p: 4,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '5px',
                            mt: 2,
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#EBEBEB',
                                    width: 200,
                                    height: 80,
                                    borderRadius: "10px",
                                    cursor: 'pointer',
                                }}
                            >
                                <img src={IMAGE_MERCHANT_URL + controller?.merchantData?.imageBanner?.url} style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: '10px',
                                    position: 'static'
                                }} alt='' />
                            </Box>

                            {/* <Box mt={2}>
                                <Typography textAlign="center">{t("branchManage_page.Add Banner Branch Image")}</Typography>
                                <Typography textAlign="center" color={TEXT_TITLE_COLOR}>Max size of 3.1 MB</Typography>
                            </Box> */}
                        </Box>
                    </Box>

                    <Box sx={{
                        p: 4,
                        boxShadow:
                            '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: '10px',
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column'
                    }}>
                        <Typography>{t("merchantDetail_page.Rating")}</Typography>
                        <Rating name="half-rating-read" defaultValue={controller.merchantData?.rate} precision={0.5} readOnly />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                    <Box
                        sx={{
                            p: 4,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '10px'
                        }}
                    >

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Branch Name English")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.nameEn} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Branch Name Laos")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.nameLa} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Abbreviate Name")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.abbreviateName} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Code")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.merchantCode} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Number")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.merchantNo} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.latitude")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.location?.coordinates[1]} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.longitude")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.location?.coordinates[0]} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Province")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.provice} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.District")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.district} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Village")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.village} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Phone")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.phone} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t("merchantDetail_page.Company")}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller.merchantData?.company} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography>{t('merchantDetail_page.Area')}</Typography>
                                    <TextField margin='normal' fullWidth required value={controller?.merchantData?.deliveryFee?.areaName} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t('merchantDetail_page.Base fee')}</Typography>
                                <TextField margin='normal' fullWidth required value={controller?.merchantData?.deliveryFee?.basePrice} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t('merchantDetail_page.Extra fee')}</Typography>
                                <TextField margin='normal' fullWidth required value={controller?.merchantData?.deliveryFee?.extraPrice} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t('merchantDetail_page.Extra distance')}</Typography>
                                <TextField margin='normal' fullWidth required value={controller?.merchantData?.deliveryFee?.extraDistance + ` ${t("Km")}`} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t('merchantDetail_page.Limit distance')}</Typography>
                                <TextField margin='normal' fullWidth required value={controller?.merchantData?.deliveryFee?.limitDistance + ` ${t("Km")}`} />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
};
export default MerchantDetailView;
